import {
  Badge,
  Box,
  Flex,
  Heading,
  ToggleButtonCard,
} from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { BreakdownButton } from './BreakdownButton';
import './styles.scss';
import { ServiceTileProps } from './types';

const getServiceTileId = (serviceName: string, id: string) =>
  `${serviceName}-${id}`;

const ServiceTile = ({
  badgeText,
  buttonText,
  breakdown,
  children,
  className,
  description,
  gap = 'md',
  isSelected,
  serviceName,
  testId,
  value,
}: ServiceTileProps) => {
  const label = isSelected ? `Chosen ${buttonText}` : `Choose ${buttonText}`;
  const descriptionId = getServiceTileId(serviceName, 'description');
  const priceId = getServiceTileId(serviceName, 'price');
  const labelId = getServiceTileId(serviceName, 'label');

  return (
    <ToggleButtonCard
      id={value}
      value={value}
      label={label}
      aria-labelledby={`${labelId} ${priceId}`}
      aria-describedby={descriptionId}
      data-testid={
        testId
          ? `service-tile-select-${testId}`
          : `service-tile-select-${serviceName}`
      }
      className={clsx('service-tile', className)}
      alignItems={{ mobile: 'stretch', tablet: 'start', desktop: 'stretch' }}
    >
      <Flex
        className={clsx('service-tile__content', className)}
        direction="column"
        alignContent="between"
        spacing={gap}
        flexGrow="1"
      >
        <Flex justifyContent="between" alignItems="center" flexShrink="0">
          <Heading id={labelId} size="sm">
            {serviceName}
          </Heading>
          {badgeText && (
            <Badge variant="subtle" colorScheme="positive" size="sm">
              {badgeText}
            </Badge>
          )}
        </Flex>
        {children}
        <Box
          className={clsx('service-tile__description', className)}
          id={descriptionId}
        >
          {description}
        </Box>
      </Flex>
      <BreakdownButton breakdown={breakdown} />
    </ToggleButtonCard>
  );
};

export { ServiceTile, getServiceTileId };
